import filePreview from './src/main'

filePreview.install = function (Vue) {
  Vue.component(filePreview.name, filePreview)
}

export default filePreview
